import React from 'react';
import { Link } from 'react-router-dom';

function EarlyAccess() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full space-y-8 bg-white p-10 rounded-3xl shadow-lg text-center">
        <div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Thank You for Your Interest!
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            The Makerstate team is hard at work putting together the full module library for release later this year.
          </p>
          <p className="mt-4 text-lg text-gray-600">
            We are offering our education <span className="font-semibold">for free</span> for all early access users. If you would like to lock in your spot and support our development for a small fee, continue below!
          </p>
        </div>
        <div className="mt-8">
          <Link
            to="/checkout" // This should now link to your actual payment/checkout page
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-lg font-medium rounded-full text-white bg-gradient-to-br from-green-400 to-blue-500 hover:bg-gradient-to-bl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition"
          >
            Lock In Early Access ($50 Fee)
          </Link>
          <p className="mt-4 text-sm text-gray-500">
            Or, continue using the free Explorer plan.
          </p>
          <Link
            to="/profile" // Link back to the profile or dashboard
            className="mt-2 inline-block text-blue-600 hover:underline"
          >
            Go back to my profile
          </Link>
        </div>
      </div>
    </div>
  );
}

export default EarlyAccess;